<template>
    <div v-show="loader" class="wf-modal-loader my-basket-spiner">
        <div class="spinner-border" role="status">
            <span class="sr-only">
                {{ $resourceString["myBasket.Loading.Label.Loading"] }}
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props: ["loader"]
}
</script>